import { useQuery } from '@tanstack/react-query';

import { getAccountBalance } from '@arrived/api_v2';
import { AccountBalanceV2, AccountId } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions } from '../../queries.utils';
import { balanceKeyFn } from '../accounts.keys';

export function useGetAccountBalanceQuery(accountId: AccountId = 0, options?: UseQueryOptions<AccountBalanceV2>) {
  return useQuery(balanceKeyFn(accountId), () => getAccountBalance(accountId), {
    ...options,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
    enabled: (options?.enabled ?? true) && !!accountId,
  });
}
